var _ = require('underscore'),
  React = require('react'),
  ClassNames = require('classnames');

var Button = require('./button.jsx'),
  CustomPropTypes = require('./types.jsx'),
  Utils = require('./utils.jsx');

var PlayPauseButton = React.createClass({
  propTypes: {
    role: React.PropTypes.string.isRequired,
    playing: React.PropTypes.bool,
    className: CustomPropTypes.ClassNameType
  },
  render: function () {
    var role = (this.props.playing) ? 'pause' : 'play',
      className = Utils.ClassNames('player-btn-' + role, this.props.className);
    return <Button role={role} icon={role} className={ClassNames(className)} {..._.omit(this.props, 'role', 'className')} />;
  }
});

module.exports = PlayPauseButton;



// WEBPACK FOOTER //
// ./src/app/components/play.jsx